import api from './api';

export interface Version {
  id: number;
  versionNumber: string;
  status: 'Production' | 'Beta' | 'Alpha' | 'Deprecated';
  changelog?: string;
  updateType?: 'Download' | 'URL';
  updateUrl?: string;
  filePath?: string;
  fileName?: string;
  fileSize?: number;
  downloadCount: number;
  applicationId: number;
  createdBy?: number;
  createdByName?: string;
  createdAt: string;
}

export const versionService = {
  getByApplication: (applicationId: number) => 
    api.get(`/versions/application/${applicationId}`),
  getRecent: () => api.get('/versions/recent'),
  create: (applicationId: number, formData: FormData) => 
    api.post(`/versions/application/${applicationId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  update: (id: number, data: Partial<Version>) => api.put(`/versions/${id}`, data),
  delete: (id: number) => api.delete(`/versions/${id}`),
  getDownloadUrl: (id: number) => `${api.defaults.baseURL}/versions/${id}/download`,
};
